import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { LazyLoad } from 'app/components/LazyLoad';
// Store
import { useSelector } from 'react-redux';
// Mui
import { Box } from '@mui/material';
// ToDO
import { selectIsWorkspacePageLastOpened, selectIsFilePageLastOpened } from 'app/store/TODO2_app/app.selectors';
// 
import PageCard from './PageCard';

type Props = {
  scrollContainer?: string;
  episodeId?: number;
  documentId: number;
  pageNum: number;
  height?: number;
  index?: number;

  showOnlyCopyAction?:boolean;
  disableBodyClick?:boolean;
}

export const PageCardWrapper:React.FC<Props> = (props) => {
  const { pathname } = useLocation<{ pathname:string }>();
  const { caseId } = useParams<{ caseId:string }>();

  const isWorkspacePage = pathname.includes('/workspace');
  const isFilePage = pathname.includes('/documents');
  const isWorkspacePageLastOpened = useSelector((state:any) => selectIsWorkspacePageLastOpened(state, { insuranceCaseId: Number(caseId), documentId: props.documentId, pageNum: props.pageNum }));
  const isFilePageLastOpened = useSelector((state:any) => selectIsFilePageLastOpened(state, { insuranceCaseId: Number(caseId), documentId: props.documentId, pageNum: props.pageNum }));

  const pageNum = typeof props.index !== 'undefined' ? props.index + 1 : props.pageNum;

  const renderPageNum = (
    <Box
      sx={{
        minWidth: 24,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        bgcolor: 'white',
        fontSize: '0.875rem',
        fontWeight: 500,
        py: 0.5,
        px: 1.5,
        textAlign: 'center'
      }}
    >{pageNum}</Box>
  );

  return (
    <LazyLoad
      // classNamePrefix="card-page"
      container={props.scrollContainer || '#scrollContainer'}
      // height={props.height}
      placeholder={
        <div
          react-page-num={pageNum}
          react-last-workspace-opened-page={Boolean(isWorkspacePage && isWorkspacePageLastOpened).toString()}
          react-last-file-opened-page={Boolean(isFilePage && isFilePageLastOpened).toString()}
          className="card-page-placeholder"
          style={{
            height: props.height
          }}
        >
          <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
            {renderPageNum}
          </Box>
        </div>
      }
      delay={250}
      // debounce={false}
      // throttle={250}
    >
      <PageCard {...props} />
    </LazyLoad>
  )
}

export default React.memo(PageCardWrapper);